import { render, staticRenderFns } from "./ShowCargasDeFamiliaComponent.vue?vue&type=template&id=54d5f4b6&scoped=true&"
import script from "./ShowCargasDeFamiliaComponent.vue?vue&type=script&lang=js&"
export * from "./ShowCargasDeFamiliaComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54d5f4b6",
  null
  
)

export default component.exports